import { USERS, PROPERTIES } from '../../../firebase';
import { brrrrCriteria } from './formSections';

export default {
  pathToSource: [
    {
      type: 'collection',
      value: USERS,
    },
    {
      type: 'user',
      value: 'uid',
    },
    {
      type: 'collection',
      value: PROPERTIES,
    },
    {
      type: 'param',
      value: 'propertyId',
    },
  ],

  inputs: {
    title: '',
    description: '',
    doNotReset: true,
    schema: [{ ...brrrrCriteria, sectionNoHeader: true }],
  },
};
